import {inject, onUnmounted, ref, Ref, watch} from "vue";
import {FormKey, FormProvider, ValidatorRule} from "@/composable/ui/useForm";

export default function useFormField<T = unknown>(value: Ref<T>, rules: Ref<ValidatorRule<T>>, dependencyValue?: Ref<string | number | undefined>, disableRequired?: boolean) {

  const form = inject(FormKey);
  const input = form?.registerInput({value, rules}, dependencyValue, disableRequired);
  const error = input?.error || ref('');

  onUnmounted(() => {
    if(form && input) form.unregisterInput(input.id);
  });

  return {
    error: error,
  };
}
